import React from "react";
import {
  Card,
  Row,
  Col,
  Typography,
  Progress,
  Statistic,
} from "antd";
import {
  CheckCircleOutlined,
  ClockCircleOutlined,
} from "@ant-design/icons";

const { Title, Text } = Typography;

const ProgressCard = ({ progress }) => {
  if (!progress) return null;

  const {
    completed_points = 0,
    total_points = 0,
    completion_percentage = 0,
  } = progress;

  const remainingPoints = Math.max(
    total_points - completed_points,
    0
  );

  return (
    <Card
      style={{
        marginBottom: 16,
        borderRadius: 8,
      }}
      bodyStyle={{
        padding: 18,
      }}
    >
      <Title
        level={5}
        style={{
          marginBottom: 20,
        }}
      >
        Delivery Progress
      </Title>

      <Progress
        percent={completion_percentage}
        strokeColor="#1677ff"
        size="default"
      />

      <Row
        gutter={16}
        style={{
          marginTop: 24,
        }}
      >
        <Col span={12}>
          <Statistic
            title="Completed"
            value={completed_points}
            prefix={<CheckCircleOutlined />}
            valueStyle={{
              color: "#52c41a",
            }}
          />
        </Col>

        <Col span={12}>
          <Statistic
            title="Remaining"
            value={remainingPoints}
            prefix={<ClockCircleOutlined />}
            valueStyle={{
              color: "#faad14",
            }}
          />
        </Col>
      </Row>

      <div
        style={{
          marginTop: 18,
          padding: 12,
          borderRadius: 6,
          background: "#fafafa",
          border: "1px solid #f0f0f0",
        }}
      >
        <Row justify="space-between">
          <Text type="secondary">
            Total Stops
          </Text>

          <Text strong>
            {total_points}
          </Text>
        </Row>

        <Row
          justify="space-between"
          style={{
            marginTop: 8,
          }}
        >
          <Text type="secondary">
            Progress
          </Text>

          <Text strong>
            {completed_points} / {total_points}
          </Text>
        </Row>
      </div>
    </Card>
  );
};

export default ProgressCard;